/**
 * TanStack Query hooks for `data-visibility-toggle-assigned-users-only-vs-all`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dataVisibilityToggleAssignedUsersOnlyVsAllQueryKeys,
	type CreateDataVisibilityToggleAssignedUsersOnlyVsAllBody,
	type ListDataVisibilityToggleAssignedUsersOnlyVsAllResponse,
	type DataVisibilityToggleAssignedUsersOnlyVsAllRow,
} from "./api";

export function useDataVisibilityToggleAssignedUsersOnlyVsAllList(): UseQueryResult<ListDataVisibilityToggleAssignedUsersOnlyVsAllResponse, Error> {
	return useQuery({
		queryKey: dataVisibilityToggleAssignedUsersOnlyVsAllQueryKeys.list(),
		queryFn: list,
	});
}

export function useDataVisibilityToggleAssignedUsersOnlyVsAllCreate(): UseMutationResult<DataVisibilityToggleAssignedUsersOnlyVsAllRow, Error, CreateDataVisibilityToggleAssignedUsersOnlyVsAllBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dataVisibilityToggleAssignedUsersOnlyVsAllQueryKeys.all });
		},
	});
}

export function useDataVisibilityToggleAssignedUsersOnlyVsAllDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dataVisibilityToggleAssignedUsersOnlyVsAllQueryKeys.all });
		},
	});
}
